export class AuthenticationOptionsResponseModel {
    constructor(
      public authenticationMethods:Array<string>
    ) {}
}

export class InitiateEnrollmentRequestModel {
  constructor(
    public purpose:string,
  ) {}
}

export class EnrollRequestModel {
  constructor(
    public authenticationMethod:string,
    public identityId:string,
    public enrollmentTrackerId:string,
    public data:string,
    public purpose:string,
  ) {}
}

export class SetAuthMethodRequestModel {
  constructor(
    public authenticationMethod:string,
    public identityId:string,
    public enrollmentTrackerId:string,
    public data:string,
  ) {}
}

export class EnrollAccountResponseModel {
  constructor(
    public currentStatus:string,
    public registrationState:RegistrationStateModel,
    public profileId:string,
    public enrollmentTrackerId:string,
    public authMethodConfiguration:any,
  ) {}
}

export class RegistrationStateModel {
  constructor(
    public title:string,
    public pageDescription:string,
    public enrollmentStepActionName:string,
    public restartEnrollmentStepActionName:string,
    public parameters:Array<FormParametersModel>,
  ) {}
}

export class FormParametersModel {
  constructor(
    public title:string,
    public name:string,
    public controlType:string,
    public required:FormParametersModel,
    public value:string,
    public hidden:boolean,
    public patternMessage: string,
  ) {}
}

export class StartFidoRegistrationRequestModel {
  constructor(
    public sessionId:string
  ) {}
}

export class FinishFidoRegistrationRequestModel {
  constructor(
    public deviceName: string,
    public newDeviceName: string,
    public existingDevice: boolean = false,
    public sessionId: string,
    public response: String
  ) {}
}

export class FingerScannerModel {
  constructor(
    public deviceName: string,
    public deviceType: number,
    public serialNumber: string
  ) {}
}

export class FingerModel {
  constructor(
    public objectID: number,
    public objectName: string
  ) {}
}


export class FingerprintResponse {
  constructor(
    public ObjectID: number,
    public ObjectName: string,
    public Quality: number,
    public UnavailabilityReason: number,
    public ImageSizeX: number,
    public ImageSizeY: number,
    public Dpi: number,
    public BoundingBox: any,
    public Outputs: FingerprintResponseData[]
) {}
}

export class FingerprintResponseData {
  constructor(
    public Format: string,
    public Base64Data: string,
    public ErrorMessage: string
) {}
}
